<template>
  <div class="h-100" style="position: static;">
    <Dialog :visible.sync="generalDialogStatus" center :title="generalDialogTitle" width="420px" @close="$store.state['app-state'].generalDialogStatus = false">
      <div align="center" style="word-break: break-word; font-size: 11pt" class="mb-3 p-3" v-html="generalDialogMessage"></div>
    </Dialog>

    <loadingSpinner v-show="$store.state.ajaxManager.loadingRequests"></loadingSpinner>
    <router-view v-show="!$store.state['app-state'].isLoading"></router-view>
  </div>
</template>
<script>
import loadingSpinner from '@/components/LoadingSpinner.vue'
import {mapState} from 'vuex'
import {Dialog} from 'element-ui'

export default {
  computed: {
    ...mapState('ajaxManager', ['loadingRequests']),
    ...mapState('app-state', ['generalDialogStatus', 'generalDialogTitle', 'generalDialogMessage', 'mediaDialogStatus', 'mediaDialogFile']),
  },
  components: {Dialog, loadingSpinner},
  beforeMount() {
    window.$gn = {}
    window.$gn.dialog = {}

    window.$gn.dialog.open = function (title, text) {
      $store.state['app-state'].generalDialogStatus = true
      $store.state['app-state'].generalDialogTitle = title
      $store.state['app-state'].generalDialogMessage = text
    }

    window.$gn.dialog.close = function (title, text) {
      $store.state['app-state'].generalDialogStatus = false
      $store.state['app-state'].generalDialogTitle = '-'
      $store.state['app-state'].generalDialogMessage = '-'
    }

    document.body.style.direction = this.$langConfig.dir;
    document.body.style.textAlign = this.$langConfig.align;
  }
}
</script>

<style lang="css">
  @import "~ag-grid-community/dist/styles/ag-grid.css";
  @import "~ag-grid-community/dist/styles/ag-theme-bootstrap.min.css";
  @import "~ag-grid-community/dist/styles/ag-theme-material.min.css";
</style>
